import OrderComplete from '@/components/OrderComplete.vue';
import OrderReceipt from '@/components/OrderReceipt.vue';
import { useConfigStore } from '@/stores/config';
import { useModalStore } from '@/stores/modal';

export function useOrder() {
  const configStore = useConfigStore();
  const modalStore = useModalStore();

  /**
   * 영수증 사용 여부에 따라 영수증 또는 주문완료 모달 오픈
   * @param fromOrderHistory 주문내역에서 결제 했는지 여부
   */
  const openReceiptOrComplete = (fromOrderHistory: boolean) => {
    if (configStore.useReceipt) {
      modalStore.openFullScreenModal(OrderReceipt, { fromOrderHistory });
    } else {
      modalStore.openFullScreenModal(OrderComplete, { hasPayment: true });
    }
  };

  return { openReceiptOrComplete };
}
